import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
import notify from "devextreme/ui/notify"
const baseUri = "WebApi.asmx/api/TermService";
const store = {};
const mutations = {

    GET_TERM_DETAIL(state, posts) {
        state.termDetail = posts.data;
    },
    GET_CURRENT_TERMS(state, posts) {
        state.currentTerms = posts.terms;
        state.termLink = posts.link;
    },
    ACCEPT_CURRENT_TERMS() { }
};
const state = {
    currentTerms: {},
    termLink: "",
    termDetail: {}
};
const getters = {};
const actions = {

    getTermDetail({ commit }, data) {
        state.termTypeListIsLoading = true;
        axios
            .get(baseUri + '/GetDetail?TerId=' + data.terId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TERM_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveTermDateil() {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.termDetail));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success) {
                    notify(`The changes has been successfully saved`);
                }
                else { alert(`error: ${res.data.errorMessage}`) }

            });
    },
    getCurrentTerms({ commit }, { tetId }) {
        state.termTypeListIsLoading = true;
        axios
            .get(baseUri + '/GetCurrentTerms', { params: { TetId: tetId } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_CURRENT_TERMS', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    acceptCurrentTerms({ commit }) {
        state.termTypeListIsLoading = true;
        axios
            .get(baseUri + '/AcceptCurrentTerms')
            .then(res => {
                if (res.data.success == true) {
                    commit('ACCEPT_CURRENT_TERMS', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}